import {Linktype} from "../../types/linktype";

export const igemguides: Linktype[] = [
    {
        title: "How to organize a Mini Jamboree",
        link: "https://static.igem.wiki/teams/5792/mj/how-to-organize-a-mini-jamboree.pdf",
        tag: "meetup",
        author: "TUEindhoven 2025"
    },
    {
        title: "How to iGEM? An introduction to the iGEM competition from a KULeuven perspective",
        link: "https://static.igem.wiki/teams/4661/wiki/contribution/how-to-igem-guide.pdf",
        tag: "igem",
        author: "KULeuven 2023"
    },
    {
        title: "Synthetic biology handbook",
        link: "https://static.igem.wiki/teams/5178/ihp/synthetic-biology-handbook-updated.pdf",
        tag: "other",
        author: "Virginia 2022"
    },
    {
        title: "Human Practices Handbook",
        link: "https://static.igem.wiki/teams/5316/images/igem-handbook-hp.pdf",
        tag: "hp",
        author: "Barcelona-UB 2024"
    },
    {
        title: "Quick guide to entrepreneurship for iGEM projects",
        link: "https://static.igem.wiki/teams/4361/wiki/contributions/igem-tu-delft-guide-entrepreneurship-v2.pdf",
        tag: "entrepreneurship",
        author: "TU Delft 2022"
    },
    {
        title: "OXFORD iGEM 2023 GUIDE TO BIOSENSOR DESIGN AND EXECUTION",
        link: "https://static.igem.wiki/teams/4932/wiki/igem-general-handbook-of-protocols111.pdf",
        tag: "protocol",
        author: "Oxford 2023"
    },
    {
        title: "Entrepreneurship handbook",
        link: "https://static.igem.wiki/teams/5316/images/igem-handbook-ep.pdf",
        tag: "entrepreneurship",
        author: "Barcelona-UB 2024"
    },
    {
        title: "How to start an iGEM team (from scratch)",
        link: "https://static.igem.wiki/teams/5342/documents/contributions/igem-pioneer-team-starting-tutorial.pdf",
        tag: "igem",
        author: "Radboud-University 2024"
    },
    {
        title: "Synthetic Biology and iGEM Guidebook",
        link: "https://static.igem.wiki/teams/4812/wiki/igem-guide.pdf",
        tag: "igem",
        author: "NYU-Abu-Dhabi 2023"
    },
    {
        title: "JUMP guide",
        link: "https://static.igem.wiki/teams/4388/wiki/jump-guide-final-1-0.pdf",
        tag: "protocol",
        author: "KCL_UK 2022"
    },
    {
        title: "GMO-Guide",
        link: "https://static.igem.wiki/teams/5587/handbook/gmo-handbook.pdf",
        tag: "safety",
        author: "Aachen 2025   "
    },
    {
        title: "FP Handbook",
        link: "https://static.igem.wiki/teams/5316/images/igem-handbook-fp.pdf",
        tag: "plasmid-design",
        author: "Barcelona-UB 2024"
    },
    {
        title: "How to: starting an iGEM team (checklist)",
        link: "https://static.igem.wiki/teams/4660/wiki/contributions/contribution-howtoigem.pdf",
        tag: "igem",
        author: "GU-Frankfurt 2023"
    },
    {
        title: "An instruction handbook (for new team)",
        link: "https://static.igem.wiki/teams/4427/wiki/2022handbook.pdf",
        tag: "igem",
        author: "JLU_China 2022"
    },
    {
        title: "iGEM Wiki Guide ",
        link: "https://static.igem.wiki/teams/5150/project-description/igem-teccem-wiki-quick-guide.pdf",
        tag: "wiki",
        author: "TecCEM 2024"
    },
    {
        title: "Getting started with iGEM",
        link: "https://static.igem.wiki/teams/5916/education/public/igem-guide.pdf",
        tag: "igem",
        author: "Imperial 2025"
    },
    {
        title: "Fundraising Guide for iGEM teams",
        link: "https://static.igem.wiki/teams/5439/documents/fundraising-guide-igem-2024-by-tecmonterreygdl-neotech-e.pdf",
        tag: "finance",
        author: "TecMonterreyGDL 2024"
    },
    {
        title: "Quick guide to Fundraising and crowdfunding for iGEM projects",
        link: "https://static.igem.wiki/teams/4361/wiki/contributions/igem-tu-delft-guide-fundraising-and-crowdfunding.pdf",
        tag: "finance",
        author: "TU Delft 2022"
    },
    {
        title: "Software Guide",
        link: "https://static.igem.wiki/teams/5154/hardware/software-guide.pdf",
        tag: "team-system",
        author: "Cambridge 2024"
    },
    {
        title: "iGEM finance guide",
        link: "https://static.igem.wiki/teams/4721/wiki/contribution/igem-finance-guide-leiden.pdf",
        tag: "finance",
        author: "Leiden 2023"
    },
    {
        title: "A Step-by-Step iGEM Fundraising Handbook",
        link: "https://static.igem.wiki/teams/4701/wiki/handbook-on-fundraising.pdf",
        tag: "finance",
        author: "Aalto-Helsinki 2023"
    },
    {
        title: "iGEM Fundraising Helpbook",
        link: "https://static.igem.wiki/teams/5137/docs/1-fundraising-helpbook.pdf",
        tag: "finance",
        author: "Aalto-Helsinki 2024"
    },
    {
        title: "A handy guide to stakeholder identification",
        link: "https://static.igem.wiki/teams/5141/contributions/a-handy-guide-to-stakeholder-identification.pdf",
        tag: "hp",
        author: "MIT-MAHE 2024"
    },
    {
        title: "PROJECT DESCRIPTION GUIDE and Explanation of Basic Concepts",
        link: "https://static.igem.wiki/teams/5471/pdf/guide/project-guide-eng-merged.pdf",
        tag: "igem",
        author: "Patras Medicine 2024"
    },
    {
        title: "Art Exhibition's Guide",
        link: "https://static.igem.wiki/teams/4624/wiki/art-exhibition-guide-wiki.pdf",
        tag: "hp",
        author: "Thessaly 2023"
    },
    {
        title: "Patent Guide",
        link: "https://static.igem.wiki/teams/5357/contribution/patent-guide.pdf",
        tag: "entrepreneurship",
        author: "ucl 2024"
    },
    {
        title: "Quick guide to tools for rational protein engineering",
        link: "https://static.igem.wiki/teams/4361/wiki/contributions/igem-tu-delft-guide-tools-for-rational-protein-engineering.pdf",
        tag: "protein",
        author: "TU Delft 2022"
    },
    {
        title: "Developer Guide",
        link: "https://static.igem.wiki/teams/5877/hardware/developer-guide.pdf",
        tag: "hardware",
        author: "GEC-Guangzhou 2025"
    },
    {
        title: "Quick guide to controlled substances in research",
        link: "https://static.igem.wiki/teams/4361/wiki/contributions/igem-tu-delft-guide-controlled-substances.pdf",
        tag: "safety",
        author: "TU Delft 2022"
    },
    {
        title: "A guide to iGEM projects on biomineralisation",
        link: "https://static.igem.wiki/teams/4417/wiki/guidebiomineralisation-2.pdf",
        tag: "other",
        author: "UCL 2022"
    },
    {
        title: "How to make an iGEM team",
        link: "https://static.igem.wiki/teams/4388/wiki/educational-outreach/final-how-to-make-an-igem-team.pdf",
        tag: "igem",
        author: "KCL_UK 2022"
    },
    {
        title: "Project Modelling Manual for future iGEM Teams",
        link: "https://static.igem.wiki/teams/4422/wiki/collaboration/math-modeling-manual-english.pdf",
        tag: "modeling",
        author: "UAM 2022, Tec-Chihuahua 2022, USP-EEL-Brazil 2022"
        // Da sind kontaktinfos dabei zu den teams
    },
    {
        title: "iGEM for dummies",
        link: "https://static.igem.wiki/teams/5281/pdfs/igemfordummies-eng.pdf",
        tag: "igem",
        author: "HS-Alpha 2024",
        helpfulness: 1
    },
    {
        title: "Tutorial: How to Edit Your Wiki",
        link: "https://static.igem.wiki/teams/5055/page/contribution/tutorial.pdf",
        tag: "wiki",
        author: "Ionis-Paris 2024"
    },
    {
        title: "A sustainability guide for iGEM teams",
        link: "https://static.igem.wiki/teams/5749/theory/20251007-igem-uppsala-2025-guide-to-sustainability.pdf",
        tag: "sustainability",
        author: "Uppsala 2025"
    },
    {
        title: "Using GitLab",
        link: "https://static.igem.wiki/teams/4388/wiki/contributions/using-gitlab-guide.pdf",
        tag: "wiki",
        author: "KCL_UK 2022"
    },
    {
        title: "Guiding Handbook for iGEM Engagement",
        link: "https://static.igem.wiki/teams/5819/pdfs/handbook.pdf",
        tag: "hp",
        author: "SJTU-Software 2025, Tsinghua 2025, Tongji-China 2025, NJU-China 2025, NUDT-CHINA 2025"
    },
    {
        title: "Guide for small molecule molecular docking",
        link: "https://static.igem.wiki/teams/4661/wiki/contribution/guide-for-molecular-docking.pdf",
        tag: "lab",
        author: "KULeuven 2023"
    },
    {
        title: "RF Diffusion manual",
        link: "https://static.igem.wiki/teams/4818/wiki/predictions/rf-diffusion-manual.pdf",
        tag: "other",
        author: "INSAENSLyon1 2023  "
    },
    {
        title: "Guide for Inclusivity",
        link: "https://static.igem.wiki/teams/5060/neominex-inclusivity-guide.pdf",
        tag: "inclusivity",
        author: "KULeuven 2024"
    },
    {
        title: "Beyond the Natural - A Comprehensive Guide to Synthetic Biology",
        link: "https://static.igem.wiki/teams/4584/wiki/education/biologix-textbook-compressed-1.pdf",
        tag: "synbio",
        author: "KCL, Warwick, Cambridge, Oxford, Edinburgh, Exeter 2023"
    },
    {
        title: "canva basics",
        link: "https://static.igem.wiki/teams/4388/wiki/canva-guide-3-32-mb.pdf",
        tag: "design",
        author: "KCL 2022"
    },
    {
        title: "High School iGEMer 101",
        link: "https://static.igem.wiki/teams/4125/wiki/education/high-school-igemer-101.pdf",
        tag: "highschool",
        author: "Nanjing_NFLS 2022"
    },
    {
        title: "CobraVis Installation & User Guide",
        link: "https://static.igem.wiki/teams/5427/software-assets/installation-and-user-guide.pdf",
        tag: "team-system",
        author: "UAlberta 2024"
    },
    {
        title: "How to iGEM - A guide to survive iGEM",
        link: "https://static.igem.wiki/teams/5583/pdfs/how-to-igem-rubochum.pdf",
        tag: "igem",
        author: "RUBochum 2025"
    },
    {
        title: "Guide to wiki accessibility",
        link: "https://static.igem.wiki/teams/5172/pdf/accessibility-guide.pdf",
        tag: "wiki",
        author: "Sheffield 2024"
        // Beispiel für schlecht weil kein Jahr angegeben
    },
    {
        title: "Lab excursion for visually impaired and blind people",
        link: "https://static.igem.wiki/teams/4729/wiki/education-page/lab-guide.pdf",
        tag: "inclusivity",
        author: "Marburg 2023"
    },
    {
        title: "How to meetup",
        link: "https://static.igem.wiki/teams/4197/wiki/collaborations/how-to-meetup-the-guide.pdf",
        tag: "meetup",
        author: "Hamburg, Munster, Toulouse 2022"
    },
    {
        title: "Research Planning Guide 101 Human practices area",
        link: "https://static.igem.wiki/teams/4763/wiki/research-planning-guide-101.pdf",
        tag: "other",
        author: "TecMonterreyGDL 2023"
    },
    {
        title: "iGEM Sponsoring Guide: How we Fund our Team",
        link: "https://static.igem.wiki/teams/5758/education/islamabad/igem-sponsoring-guide.pdf",
        tag: "finance",
        author: "RPTU-Kaiserslautern 2025"
    },
    {
        title: "The Guide for careers in SynBio",
        link: "https://static.igem.wiki/teams/5916/education/highschool/career-guide.pdf",
        tag: "other",
        author: "Imperial 2025"
    },
    {
        title: "AI Safety Policies (Guideline)",
        link: "https://static.igem.wiki/teams/5461/ai-safety-guideline.pdf",
        tag: "ai",
        author: "LCG-China 2024"
    },
    {
        title: "A brief inquiry into de novo protein design",
        link: "https://static.igem.wiki/teams/5172/pdf/ai-redesign-cycle.pdf",
        tag: "ai",
        author: "Sheffield 2024"
    },
    {
        title: "University of Guelph iGEM Escape Room Guide",
        link: "https://static.igem.wiki/teams/5611/contribution/biosecurity-breach-igem-escape-room-guide.pdf",
        tag: "other",
        author: "Guelph 2025"
    },
    {
        title: "Human Practices Guide",
        link: "https://static.igem.wiki/teams/5754/contributionsguides/human-practices-guide.pdf",
        tag: "hp",
        author: "Barcelona-UIC 2025"
    },
    {
        title: "Algal Bioreactor",
        link: "https://static.igem.wiki/teams/6022/hardware/reactor-r3-guide.pdf",
        tag: "team-system",
        author: "ETHZurich 2025"
    },
    {
        title: "Awareness Guide",
        link: "https://static.igem.wiki/teams/5833/contributions/igem-bielefeld-2025-awareness-guide.pdf",
        tag: "hp",
        author: "Bielefeld-CeBiTec 2025"
    },
    {
        title: "Golden Gate",
        link: "https://static.igem.wiki/teams/4654/wiki/experiments/2-golden-gate-assembly.pdf",
        tag: "protocol",
        author: "TU Braunschweig 2023"
    },
    {
        title: "Alphage Installation and Usage Guide",
        link: "https://static.igem.wiki/teams/5846/wiki/software/alphage-installation-and-usage-guide.pdf",
        tag: "team-system",
        author: "CAU-China 2025"
    },
    {
        title: "NUPACK GUIDE",
        link: "https://static.igem.wiki/teams/4438/wiki/contribution/nupack-guide-team-aboa-x-team-iiser-tirupati-india.pdf",
        tag: "software",
        author: "IISER-Tirupati_India, ABOA 2022"
    },
    {
        title: "Handbook of Activity Design Volume 4: High School Students",
        link: "https://static.igem.wiki/teams/5567/education/files/volume-4-high-school.pdf",
        tag: "other",
        author: "JLU-CP 2025"
    },
    {
        title: "Nanopore Sequencing Guide",
        link: "https://static.igem.wiki/teams/5833/mirnazeug/igem-bielefeld-cebitec-ont-mirnasequencing-guide.pdf",
        tag: "lab",
        author: "Bielefeld-CeBiTec 2025"
    },
    {
        title: "Wiki Writing Guide",
        link: "https://static.igem.org/mediawiki/2019/8/89/T--Wageningen_UR--Wiki_writing_style_guide.pdf",
        tag: "wiki",
        author: "WageningenUR 2019"
    },
    {
        title: "Guide for better wiki accessibility",
        link: "https://static.igem.org/mediawiki/2021/9/93/T--TU_Darmstadt--guideline-web-accessibility.pdf",
        tag: "wiki",
        author: "TUDarmstadt 2021"
    },
    {
        title: "iGEM for dummies",
        link: "https://static.igem.org/mediawiki/2017/e/ec/Minibooklet.pdf",
        tag: "igem",
        author: "ITB_Indonesia, Manchester 2017"
    },
    {
        title: "GoGEM: How to wiki the Darmstadt way",
        link: "https://static.igem.org/mediawiki/2021/e/e2/T--TU_Darmstadt--gogem-how-to-wiki-the-darmstadt-way.pdf",
        tag: "wiki",
        author: "TUDarmstadt 2021"
    },
    {
        title: "How to set up an iGEM team",
        link: "https://static.igem.org/mediawiki/2015/a/ae/2015-Newsletter-No.1.pdf",
        tag: "igem",
        author: "Amoy ( with ETH-Zürich, NCTU_Formosa, Oxford, Paris_Bettencourt, Stockholm, SYSU-CHINA, Toulouse," +
            " TU-Eindhoven, USTC, Valencia_UPV and Waterloo) 2015"
    },
    {
        title: "Docking Simulations Tutorial",
        link: "https://static.igem.wiki/teams/4390/wiki/bioinf/docking-tutorial-v3.pdf",
        tag: "model",
        author: "Edinburgh-UHAS Ghana, Munich 2022"
    }, {
        title: "Resource Guide to Bioart Ethics",
        link: "https://static.igem.wiki/teams/4322/wiki/clean-bioart-ethics-guide.pdf",
        tag: "ethic",
        author: "Cornell 2022"
    }, {
        title: "Swiss Parliamentary Debate Study Guide",
        link: "https://static.igem.wiki/teams/4439/wiki/09-human-practices/study-guide.pdf",
        tag: "other",
        author: "EPFL 2022 HESTIA"
    }, {
        title: "Guide to using Boltz-2 for Future iGem Projects",
        link: "https://static.igem.wiki/teams/5823/pdfs/contribution/guide-to-using-boltz-2-for-future-igem-projects.pdf",
        tag: "software",
        author: "NU Boston 2025"
    }, {
        title: "Software Guide with screenshots",
        link: "https://static.igem.wiki/teams/5661/contribution/software-guide.pdf",
        tag: "team-system",
        author: "TAU-Israel 2025"
    },
    {
        title: "How To Wiki - A Brief Introduction to How This Wiki Works",
        link: "https://2024.igem.wiki/marburg/how-to-wiki",
        tag: "wiki",
        author: "Marburg 2024"
    },
    {
        title: "Wiki code - Jekyll",
        link: "https://2024.igem.wiki/sdu-china/wiki-code",
        tag: "wiki",
        author: "sdu-china 2025"
    },
    {
        title: "iGEM Ethical Guideline for Human Practices",
        link: "https://static.igem.org/mediawiki/2017/8/8f/T--Toronto--2016_igem_ethical_guideline.pdf",
        tag: "hp",
        author: "Toronto 2016"
    }
]


/*
 {
        title: "",
        link: "",
        tag: "",
        author: ""
    }
 */


// https://static.igem.wiki/teams/4320/wiki/2022-mit-igem-protocols-google-docs.pdf
// Team flyer:
// https://static.igem.wiki/teams/4588/wiki/pr-pdfs/igem-2023-brochure.pdf
// https://static.igem.wiki/teams/5194/pages/igem-2024-project-overview-2-compressed.pdf
// https://static.igem.wiki/teams/5192/igem-portfolio.pdf

//  Business plan:
// https://static.igem.wiki/teams/5545/entrepreneurship/business-plan.pdf


// Unklar:
// Inside the Dynamics of an iGEM Team